import Page from 'components/Page';
import CardText from 'components/text/CardText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SupportPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <Page className={styles.page} testId={testId}>
        <CardText text={'Exedy to provide support link'} />
    </Page>
);

export default SupportPage;
